import { Controller } from "../../lib/stimulus-shim"

export default class extends Controller {
  static targets = ["form", "email", "button", "feedback"]
  static values = {
    pageModuleId: Number,
    linkUrl: String,
    linkOnly: Boolean
  }

  submit(event) {
    event.preventDefault()

    if (this.linkOnlyValue) {
      this.trackEvent('newsletter_subscribe_click')
      window.open(this.linkUrlValue, '_blank', 'noopener,noreferrer')
      return
    }

    const email = this.emailTarget.value.trim()
    if (!email) return

    this.trackEvent('newsletter_subscribe_click')
    this.setLoading(true)
    this.clearFeedback()

    fetch('/api/v1/newsletter/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      body: JSON.stringify({
        email: email,
        page_module_id: this.pageModuleIdValue,
        profile_id: document.querySelector('[data-profile-id]')?.dataset.profileId
      })
    })
      .then(response => response.json())
      .then(data => {
        this.setLoading(false)

        if (data.success) {
          this.showFeedback(data.message, 'success')
          this.emailTarget.value = ''
          this.trackEvent('newsletter_subscribe_success')
        } else {
          this.showFeedback(data.message, 'error')
        }
      })
      .catch(() => {
        this.setLoading(false)
        this.showFeedback('Erreur reseau. Veuillez reessayer.', 'error')
      })
  }

  setLoading(loading) {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = loading
      if (loading) {
        this.buttonTarget.dataset.originalText = this.buttonTarget.textContent
        this.buttonTarget.innerHTML = '<span class="loading loading-spinner loading-xs"></span>'
      } else {
        this.buttonTarget.textContent = this.buttonTarget.dataset.originalText || "S'inscrire"
      }
    }
  }

  showFeedback(message, type) {
    if (!this.hasFeedbackTarget) return

    const alertClass = type === 'success' ? 'alert-success' : 'alert-error'
    this.feedbackTarget.innerHTML = `<div class="alert ${alertClass} alert-sm mt-2"><span>${message}</span></div>`
  }

  clearFeedback() {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.innerHTML = ''
    }
  }

  trackEvent(eventName, properties = {}) {
    if (typeof ahoy === 'undefined') return
    if (document.querySelector('meta[name="rho-owner"]')) return

    try {
      ahoy.track(eventName, {
        ...properties,
        page_module_id: this.pageModuleIdValue,
        profile_id: document.querySelector('[data-profile-id]')?.dataset.profileId
      })
    } catch (e) {
      console.warn('Failed to track event:', e)
    }
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }
}
